"use client";


export default function Error(){
    return (
        <div>
            <h1>ERROR</h1>
            <h2>Page not found</h2>
        </div>
    )
}